const components = require('data/components.json');

const componentsByType = {};
const componentDict = {};
const combinationComponentsByType = {};

components.forEach((component) => {
  let array = componentsByType[component.type];
  if (array == null) {
    array = componentsByType[component.type] = [];
  }
  array.push(component);

  if (component.tag && component.tag.indexOf('combination') >= 0) {
    array = combinationComponentsByType[component.type];
    if (array == null) {
      array = combinationComponentsByType[component.type] = [];
    }
    array.push(component);
  }

  componentDict[component.id] = component;
});

const componentTypes = Object.keys(componentsByType);
const combinationComponentTypes = Object.keys(combinationComponentsByType);

export default {
  get componentTypes() {
    return componentTypes;
  },
  get combinationComponentTypes() {
    return combinationComponentTypes;
  },
  getComponent(id) {
    return JSON.parse(JSON.stringify(componentDict[id]));
  },
  getComponentsByType(type) {
    return componentsByType[type];
  },
  getCombinationComponentsByType(type) {
    return combinationComponentsByType[type];
  }
};



// WEBPACK FOOTER //
// ./src/services/component-database.js